import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CartService } from '../api';
import { CartItem } from './model/cart-item-model';
import {MdDialog, MdDialogRef} from '@angular/material';
import {SongDetailComponent} from '../';
import { SongsService} from '../api';
import { PlayerService } from '../player/services/player.service';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import 'intl';
import 'intl/locale-data/jsonp/en';
const OFFSET_HEIGHT: number = 270
const PRODUCT_HEIGHT: number = 48

@Component({
  selector: 'cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
  products: Array<CartItem>;
  numProducts: number = 0;
  animatePlop: boolean = false;
  animatePopout: boolean = false;
  expanded: boolean = false;
  expandedHeight: number;
  cartTotal: number = 0;
  changeDetectorRef: ChangeDetectorRef;
  @BlockUI() blockUI: NgBlockUI;
  dialogRef2: MdDialogRef<SongDetailComponent>;
  private song:any;
  public creditsArray: any = [];
  public writersArray: any = [];
  public onlineOffline: boolean = navigator.onLine;

  constructor(private cartService: CartService,private playerService: PlayerService,private songService: SongsService,public dialog: MdDialog, changeDetectorRef: ChangeDetectorRef) {
    window.addEventListener('online', () => {this.onlineOffline = true;});
    window.addEventListener('offline', () => {this.onlineOffline = false});
    if(this.onlineOffline) {
      cartService.cart$.subscribe(updatedCart => {
        this.products = updatedCart;
        this.numProducts = this.products.length;
        //Make a plop animation
        if (this.numProducts > 1) {
          this.animatePlop = true;
          setTimeout(() => {
            this.animatePlop = false;
          }, 160)
        } else if (this.numProducts == 1) {
          this.animatePopout = true;
          setTimeout(() => {
            this.animatePopout = false;
          }, 300);
        }
        this.expandedHeight = (this.numProducts * PRODUCT_HEIGHT + OFFSET_HEIGHT) ;
        if (!this.numProducts) {
          this.expanded = false;
        }
      });
    }
  }

  onClickedOutside(e: Event) {
    this.close();
  }

  ngOnInit() {
    this.expandedHeight = 0;
    this.cartService.getCart();
  }

  deleteProduct(product) {
    if(this.onlineOffline){
      this.cartService.removeItem(product);
    }
  }

  deleteProducts(products) {
    if(this.onlineOffline) {
      this.cartService.flushCart();
    }
  }

  onCartClick() {
    this.expanded = !this.expanded;
  }

  close(){
    if(this.expanded == true){
      this.expanded = false;
    }
  }

  openSongDetail(song) {
    this.blockUI.start('Loading, please wait...');
    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);
    width = '37%';
    setTimeout(()=> {
      this.dialogRef2 = this.dialog.open(SongDetailComponent, {
        width: width
      });
      this.dialogRef2.componentInstance.slug = song.slug;
      return false;
    },2000)
  }

}



// WEBPACK FOOTER //
// ./src/app/cart/cart.component.ts